<template>
  <div v-cloak class="user-message">
    <div class="titles-right">志愿者信息</div>
    <div class="message">
      <div class="userimg">
        <img v-if="imageUrl" :src="formData.ImageUrl" class="avatar" />
        <img src="../img/moren.png" alt="" v-else />
        <el-upload
          class="avatar-uploader"
          id="upl"
          action
          :show-file-list="false"
          :http-request="picUpload"
          :before-upload="beforeAvatarUpload"
          >修改图片</el-upload
        >
      </div>
      <div class="names">
        <span>姓名：</span>
        <el-input type="text" v-model="formData.Name" disabled></el-input>
      </div>
      <div class="names">
        <span>报名服务类型：</span>
        <el-input type="text" v-model="formData.Type" disabled></el-input>

        <!-- <el-select v-model="formData.Type" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select> -->
      </div>
      <div class="names">
        <span>手机号码：</span>
        <el-input type="text" v-model="formData.Phone" disabled></el-input>
      </div>
      <div class="names">
        <span>邮箱：</span>
        <el-input type="text" v-model="formData.Email"></el-input>
      </div>
      <div class="names">
        <span>微信号：</span>
        <el-input type="text" v-model="formData.Wechat"></el-input>
      </div>
      <!-- <div class="names">
        <span>推荐码：</span>
        <el-input type="text" v-model="formData.Code"></el-input>
      </div> -->
      <div class="namess">
        <span class="ma-r-15">简历：</span>
        {{ formData.UrlName
        }}<a :href="formData.Url" class="c-red ma-l-10">点击下载</a>

        <el-upload
          action=""
          ref="uploadHeadimageFile"
          :show-file-list="true"
          :http-request="httpRequestFile"
          :limit="1"
        >
          <div class="btn-upload ma-t-10">上传附件</div>
        </el-upload>
      </div>
    </div>
    <div class="btns">
      <div @click="tj" class="save">保存</div>
    </div>
  </div>
</template>

<script>
import {
  getuser,
  userchangepassword,
  aliupload,
  getVolunteerDetail,
  getVolunteerAdd,
} from "../api.js";
import axios from "axios";

var _this;
export default {
  name: "User-message",
  props: {},
  data() {
    return {
      fetch_static: false,
      imageUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      uname: "",
      uphone: "",
      uemail: "",
      usex: 5,
      id: "",
      newp: "",
      newsp: "",
      oldp: "",
      pro: false,
      nickName: "",
      formData: {
        Name: "",
        Type: "",
        Phone: "",
        Email: "",
        Wechat: "",
        Code: "",
        ImageUrl: "",
        Url: "", //附件
        UrlName: "",
      },
      options: [
        "SHISW宣传大使",
        "城市展映统筹",
        "校园展映统筹",
        "校园自媒体号",
        "采访撰稿",
        "影评撰稿",
        "媒体联络",
        "插画师",
        "漫画师",
        "平面设计师",
        "创意短视频策划/拍摄/制作",
        "动画制作",
        "平面摄影师",
        "摄像师",
        "中英文翻译（文本）",
        "同声传译翻译",
      ],
    };
  },
  created() {
    _this = this;
    this.usermessage();
    //获取志愿者信息
    _this.loadDataDetail();
  },
  // 其他页面进来时更新初始数据
  activated() {
    if (this.$route.meta.title == "false") {
      this.usermessage();
    }
  },
  methods: {
    //获取志愿者信息
    loadDataDetail() {
      getVolunteerDetail().then((res) => {
        _this.formData = res.data.Data;
      });
    },
    // 个人信息
    usermessage() {
      let token = localStorage.getItem("AccessToken");
      let datas = {
        token: token,

        source: "pc",
      };
      getuser(datas).then((res) => {
        console.log(res);
        if (res.data.Code == 0) {
          let result = res.data.Data;
          this.imageUrl = result.HeadImage;
          this.uname = result.Name;
          this.uphone = result.Phone;
          this.uemail = result.Email;
          this.usex = result.Gender;
          this.nickName = result.Nickname;
        }
      });
    },

    names(e) {
      this.uname = e;
      this.fetch_static = false;
    },
    phone(e) {
      this.uphone = e;
      this.fetch_static = false;
    },
    email(e) {
      this.uemail = e;
      this.fetch_static = false;
    },
    sex(e) {
      this.usex = e;
      this.fetch_static = false;
    },
    // 原密码
    oldpassword(e) {
      this.oldp = e;
    },
    // 新密码1
    newpassword(e) {
      this.newp = e;
    },
    // 确认密码
    newpasswords(e) {
      this.newsp = e;
    },

    // 修改密码
    submitForm() {
      let p1 = this.newp;
      let p2 = this.newsp;
      let token = localStorage.getItem("AccessToken");
      // let oldp = localStorage.getItem("password");//如果是验证码登录，则没有旧密码，因此这里去除。
      let oldps = this.oldp;

      // if (oldps != oldp) {
      //   this.$message.error("原密码不正确");
      //   return;
      // }

      if (p1 == "" || p2 == "") {
        this.$message.error("密码不能为空");
        return;
      }

      if (/[\u4E00-\u9FA5]/g.test(p1)) {
        this.$message.error("密码不能有汉字");
        return;
      }

      if (/[\u4E00-\u9FA5]/g.test(p2)) {
        this.$message.error("密码不能有汉字");
        return;
      }

      if (p1 != p2) {
        this.$message.error("二次密码不一致");
        return;
      }

      let datas = {
        Language: 1,
        Token: token,
        OldPassword: oldps,
        Password: p1,
        Password2: p2,
        Source: "pc",
      };

      userchangepassword(datas).then((res) => {
        // console.log(res)
        if (res.data.Code == 0) {
          this.$message({
            message: "密码修改成功",
            type: "success",
          });

          localStorage.setItem("password", p1);
          this.oldp = "";
          this.newp = "";
          this.newsp = "";
          this.$refs.pro.doClose();
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },

    // 保存
    tj() {
      if (!_this.formData.ImageUrl) {
        _this.$message.error("个人头像数据为空");
        return false;
      }
      if (!_this.formData.Name) {
        _this.$message.error("姓名数据为空");
        return false;
      }
      if (!_this.formData.Type) {
        _this.$message.error("报名类型数据为空");
        return false;
      }
      if (!_this.formData.Phone) {
        _this.$message.error("手机号码据为空");
        return false;
      }
      if (!_this.formData.Email) {
        _this.$message.error("邮箱数据为空");
        return false;
      }
      if (!_this.formData.Wechat) {
        _this.$message.error("微信数据为空");
        return false;
      }
      if (!_this.formData.Url) {
        _this.$message.error("简历数据为空");
        return false;
      }

      //格式验证
      var e =
        /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      if (!e.test(_this.formData.Email)) {
        _this.$message.error("邮箱格式不正确！");
        return false;
      }

      var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;
      if (!reg.test(_this.formData.Phone)) {
        _this.$message.error("手机格式不正确！");
        return false;
      }

      getVolunteerAdd(_this.formData)
        .then((res) => {
          if (res.data.Code == 0) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          } else {
            this.$message.error(res.data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    picUpload(file) {
      let that = this;
      let datas = {
        bucketName: "",
        area: "",
        folder: "User|Image",
      };
      aliupload(datas).then((res) => {
        if (res.data.Code == 0) {
          var formData = new FormData();
          let key = res.data.Data.Dir + res.data.Data.Key + file.file.name;
          formData.append("key", key);
          formData.append("OSSAccessKeyId", res.data.Data.OSSAccessKeyId);
          formData.append("policy", res.data.Data.Policy);
          formData.append("Signature", res.data.Data.Signature);
          formData.append("file", file.file);
          formData.append("success_action_status", 200);
          let url = res.data.Data.Host;
          let data = formData;
          let imgurl = url + "/" + key;

          axios({
            url: url,
            method: "post",
            data: data,
          }).then(function (datas) {
            console.log(datas);
            that.formData.ImageUrl = imgurl;
          });
        }
      });
    },

    //文件上传，自定义上传方式，上传简历
    httpRequestFile(e) {
      console.log("e");
      var data = new FormData();
      data.append("file", e.file);
      data.append("Folder", "volunteer");
      axios({
        url: "http://api.shisw.net/V1/Common/AliyunOSS/FileUpload",
        method: "post",
        data: data,
        onUploadProgress: progressEvent => {
                        let percent = (progressEvent.loaded / progressEvent.total * 100) | 0
                        e.onProgress({ percent: percent });//调用uploader的进度回调
                    },
      }).then(function (res) {
          _this.formData.UrlName = e.file.name;
          _this.formData.Url = res.data.Data.FilePath;
        }).catch(() => {
          _this.$message.error("上传失败，请重试");
          return false;
        });
    },

    beforeAvatarUpload(file) {
      this.fetch_static = false;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
  },
};
</script>

<style lang="scss" scoped>
.ma-r-15 {
  margin-right: 15px;
}
.green {
  background: #fb004d;
}
.btn-upload {
  cursor: pointer;
  width: 126px;
  height: 32px;
  border-radius: 20px;
  border: 1px solid #fb004d;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: #fb004d;
  text-align: center;
  line-height: 32px;
  margin-left: 23px;
}
.user-message {
  width: 960px;
  min-height: 800px;

  background: #ffffff;
  padding-top: 16px;
  padding-bottom: 161px;
  padding-left: 56px;
  box-sizing: border-box;
  margin-bottom: 40px;
  .el-upload {
    width: 100%;
  }
  .el-popover {
    z-index: 8 !important;
  }
  .titles-right {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 24px;
  }
  .titles-right:before {
    content: "|";
    display: inline-block;
    width: 4px;
    height: 19px;
    background: #fb004d;
    color: #fb004d;
    border-radius: 2px;
    margin-right: 8px;
  }
  .message {
    height: auto;
    margin-top: 43px;
    margin-bottom: 66px;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(51, 51, 51, 1);
    font-weight: 540;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .names {
      width: 50%;
      border-bottom: 1px solid #e6e6e6;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 10px;
      padding-top: 10px;
      span {
        width: 30%;
        text-align: right;
      }
      .el-input {
        width: 70%;
      }
      .el-input__inner {
        border: none;
      }
    }
    .namess{
      width: 100%;
      border-bottom: 1px solid #e6e6e6;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 10px;
      padding-top: 10px;
      span {
        width: 15%;
        text-align: right;
      }
      .el-input {
        width: 20%;
      }
      .el-input__inner {
        border: none;
      }
    }
    .userimg {
      //   margin-top: 80px;
      //   margin-bottom: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }
      .avatar-uploader {
        cursor: pointer;
        width: 126px;
        height: 32px;
        border-radius: 20px;
        border: 1px solid #fb004d;
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #fb004d;
        text-align: center;
        line-height: 32px;
        margin-left: 23px;
      }
    }
  }
  .btns {
    text-align: center;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .save {
      width: 208px;
      height: 40px;
      border-radius: 20px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      line-height: 40px;
      color: #ffffff;
      background: #fb004d;
      margin-right: 40px;
      cursor: pointer;
    }
    .change {
      width: 208px;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      line-height: 40px;
      color: #fb004d;
      border: 1px solid #fb004d;
      display: flex;
      align-items: center;
    }
    .el-button {
      width: 208px;
      height: 40px;
      border: 1px solid #fb004d;
      color: #fb004d;
      border-radius: 20px;
    }
  }
}
</style>
